export enum EnumOption {
  GetAll = 1,
  GetbyId = 2,
  Add = 3,
  Update = 4,
  Delete = 5,
  ActionList = 6,
  Resend = 7
}

export enum EnumTypeCommon {
  DropDown = 1,
  Radio = 2,
  CheckBox = 3
}


export enum EnumAction {
  View,
  Add,
  Edit,
  Delete,
  Export,
  AdjustPoint,
  ManagerUser,
  Eye,
  Detail,
  CancelTopup
}